import { render } from "./billList.vue?vue&type=template&id=1f998e5c&scoped=true"
import script from "./billList.vue?vue&type=script&lang=js"
export * from "./billList.vue?vue&type=script&lang=js"

import "./billList.vue?vue&type=style&index=0&id=1f998e5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f998e5c"]])

export default __exports__